import cn from 'classnames'
import React, { PureComponent } from 'react'
import Link from 'redux-first-router-link'

import { Form, Button, TextArea, Icon } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import { Tip } from 'shared/components/ui/Typography'
import ValidatedField from 'shared/components/ui/ValidatedField'

import sharedStyles from '../../../sharedForm/styles.less'
import { COMPLETED_PAGE } from '../../pages'

import styles from '../styles.less'

export default class AddTeamMembersMultiInputFormView extends PureComponent {
  handleChange = (name, _, { value, checked }) => {
    const { onChange } = this.props
    onChange(name, checked === undefined ? value : checked)
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    onValidate(name, formFields[name])
  }

  render() {
    const {
      switchInputMode,
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
      invitationErrors,
      backPageType,
    } = this.props

    return (
      <Form size="large" className={sharedStyles.form}>
        <Form.Field className={styles.multiInputHelp}>
          Please enter one email address per line (max. 25):
        </Form.Field>
        <Form.Field>
          <ValidatedField
            placeholder={
              'team-member@organization.com\nteam-member@organization.com'
            }
            type="text"
            value={formFields.multiEmailAddressInput}
            validatedFieldComponent={TextArea}
            errorMessage={formFieldsErrors.multiEmailAddressInput}
            onChange={propFunc(this.handleChange, 'multiEmailAddressInput')}
            onBlur={propFunc(this.handleBlur, 'multiEmailAddressInput')}
            fieldRefCallback={disableLastPassInputRef}
            rows={8}
          />
        </Form.Field>
        <Form.Field>
          Need to add only a few {app.t('agents')} ?{' '}
          <a onClick={switchInputMode}>Click here</a>
        </Form.Field>
        <Form.Field>
          <hr />
        </Form.Field>
        {!!invitationErrors &&
          invitationErrors.map((error, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Form.Field key={`onboarding-addteam-single-error-${index}`}>
              <Tip color="berry" className={styles.errorMessage}>
                <Icon name="times circle outline" />
                {error}
              </Tip>
            </Form.Field>
          ))}
        {!!invitationErrors && (
          <Form.Field>
            <hr />
          </Form.Field>
        )}
        <Form.Group>
          <Form.Field width={4}>
            <Link to={{ type: backPageType }}>
              <Button size="big" fluid basic>
                Back
              </Button>
            </Link>
          </Form.Field>
          <Form.Field width={12}>
            <Button
              primary
              size="big"
              fluid
              disabled={!canSave}
              onClick={submitForm}
            >
              {!saving ? 'Invite' : 'Sending invites...'}
            </Button>
            <Link
              to={{ type: COMPLETED_PAGE }}
              className={cn(sharedStyles.skipStep, styles.skipStep)}
            >
              Skip this step
            </Link>
          </Form.Field>
        </Form.Group>
      </Form>
    )
  }
}
